import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=52db0f0d&scoped=true"
import script from "./AddProject.vue?vue&type=script&lang=js"
export * from "./AddProject.vue?vue&type=script&lang=js"
import style0 from "./AddProject.vue?vue&type=style&index=0&id=52db0f0d&prod&lang=css"
import style1 from "../../statistics/css/addProject.css?vue&type=style&index=1&id=52db0f0d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db0f0d",
  null
  
)

export default component.exports